// 请不要随意修改，否则可能造成程序出错，修改代码请参照 USAGE.md 文件！！！

import cryptoJs from 'crypto-js'

export default {
    encrypt(key, word) {
        let _key = cryptoJs.enc.Hex.parse(key)
        let enc = cryptoJs.AES.encrypt(word, _key, {
            mode: cryptoJs.mode.ECB,
            padding: cryptoJs.pad.Pkcs7
        })
        return enc.ciphertext.toString()
    },
    decrypt(key, word) {
        let _key = cryptoJs.enc.Hex.parse(key)
        let dec = cryptoJs.AES.decrypt(cryptoJs.format.Hex.parse(word), _key, {
            mode: cryptoJs.mode.ECB,
            padding: cryptoJs.pad.Pkcs7
        })
        return cryptoJs.enc.Utf8.stringify(dec)
    }
}
